import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageBanner from "../../components/PageBanner";
import Pagination from "../../components/Pagination";
import InfographicCard from "../../components/card/InfographicCard";
import BannerService from "../../services/banner";
import InfographicService from "../../services/infographic";
import { infographicSize } from "../../configs/pageSize";
import { ComingSoonBox } from "../ComingSoon";

// ยังไม่มีแบนเนอร์ caption "infographic" ใน Strapi ใช้ของหน้าบทความ (id 4) ไปก่อน
const FALLBACK_BANNER_ID = 4;

export default function Infographic() {
  const { lang } = useParams();
  const [items, setItems] = useState(null);
  const [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    if (lang !== "th" && lang !== "en") window.open("/th", "_self");
  }, [lang]);

  useEffect(() => {
    window.scrollTo(0, 0);
    BannerService.getBannerByCaption("infographic", FALLBACK_BANNER_ID).then(setBanner);
  }, []);

  useEffect(() => {
    InfographicService.getInfographics({ page, pageSize: infographicSize }).then(
      ([data, m]) => {
        setItems(data);
        setMeta(m || {});
      }
    );
  }, [page]);

  const total = meta?.pagination?.total ?? 0;

  return (
    <div id="resource" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th="สื่ออินโฟกราฟิก"
        text_en="Infographic"
        banner={banner?.banner}
        bannerText={[{ name: "Infographic", href: "/infographic" }]}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          <div className="mt-[64px] sm:mt-[92px] mb-[160px] sm:mb-[300px]">
            <h1 className="text-heading font-bold text-slateGray text-left">
              {lang === "en" ? "Infographic" : "อินโฟกราฟิก"}
            </h1>
            {items && items.length > 0 && (
              <p className="text-lead font-bold text-slateGray text-left mt-[16px]">
                {lang === "en" ? "All" : "ทั้งหมด"} ({total})
              </p>
            )}

            {items && items.length === 0 && <ComingSoonBox lang={lang} />}

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-[16px] sm:gap-[28px] mt-[28px]">
              {items &&
                items.map((item) => (
                  <InfographicCard key={item.documentId || item.id} data={item} lang={lang} />
                ))}
            </div>

            {items && items.length > 0 && (
              <Pagination
                length={meta?.pagination?.pageCount ?? ""}
                selected={page}
                function={(i) => {
                  setPage(i);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
